import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "charts";

@Injectable({
  providedIn: "root",
})
export class ChartsHandlerService {
  constructor(private APIService: ApiService) {}

  postChart(masterAccountID: number, chartObj: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, chartObj);
  }
}
